import React, { useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = "Text eingeben...",
  className = ""
}) => {
  // Minimale Toolbar mit nur den wichtigsten Formatierungsoptionen
  const modules = {
    toolbar: [
      ['bold', 'italic'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['clean'] // Formatierung entfernen
    ],
  };

  // Erlaube nur bestimmte Formate
  const formats = [
    'bold', 'italic',
    'list', 'bullet'
  ];

  // CSS Styles als Objekt für die inline Verwendung
  useEffect(() => {
    // Füge die CSS-Styles zum head hinzu
    const styleId = 'rich-text-editor-styles';
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;
    
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      styleElement.textContent = `
        .rich-text-editor .ql-toolbar {
          border-top: 1px solid #e5e7eb;
          border-left: 1px solid #e5e7eb;
          border-right: 1px solid #e5e7eb;
          border-bottom: none;
          border-top-left-radius: 0.375rem;
          border-top-right-radius: 0.375rem;
          background: #f9fafb;
        }
        
        .rich-text-editor .ql-container {
          border-bottom: 1px solid #e5e7eb;
          border-left: 1px solid #e5e7eb;
          border-right: 1px solid #e5e7eb;
          border-top: none;
          border-bottom-left-radius: 0.375rem;
          border-bottom-right-radius: 0.375rem;
          font-family: inherit;
        }
        
        .rich-text-editor .ql-editor {
          min-height: 80px;
          font-size: 0.875rem;
          line-height: 1.5;
        }
        
        .rich-text-editor .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: italic;
        }
        
        .rich-text-editor .ql-toolbar .ql-formats {
          margin-right: 10px;
        }
        
        .rich-text-editor .ql-toolbar button {
          width: 28px;
          height: 28px;
        }
        
        .rich-text-editor .ql-toolbar button:hover {
          color: #2563eb;
        }
        
        .rich-text-editor .ql-toolbar button.ql-active {
          color: #2563eb;
        }
      `;
      document.head.appendChild(styleElement);
    }
  }, []);

  return (
    <div className={`rich-text-editor ${className}`}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '0.375rem',
        }}
      />
    </div>
  );
};

export default RichTextEditor;